<template>
  <vs-popup
    class="taste-panel-create-popup"
    id="popup"
    :title="updateMode ? 'Update Taste Form' : 'Create Taste Form'"
    @close="open = false"
    :active.sync="open"
    :buttons-hidden="true"
  >
    <vx-card no-shadow>
      <ValidationObserver ref="form" v-slot="{ handleSubmit }">
        <form
          id="create-form-test-popup"
          @submit.prevent="handleSubmit(createTest)"
          autocomplete="off"
          class="p-4"
        >
        <div
            class="vx-row"
            v-if="updateMode"
          >
            <div class="vx-col w-full md:w-1/4 flex items-center">
              <label class="text-sm font-semibold mb-1"
                >Batch Code : {{ batchCode }}</label
              >
            </div>
          </div>
          <div
            class="vx-row"
            v-if="updateMode"
          >
            <div class="vx-col w-full mb-3 md:w-1/4 flex items-center">
              <label class="text-sm font-semibold mb-1"
                >Done By : {{ doneBy.name ? doneBy.name : 'N/A' }}</label
              >
            </div>
          </div>
          <div class="vx-row mb-6 border rounded-lg p-4 bg-gray-50">

            <div class="vx-col w-full md:w-1/2 flex items-center mb-4 md:mb-0">
              
              <div class="w-1/3 pr-3">
                <label class="text-sm font-semibold">Type</label>
              </div>

             
              <div class="w-2/3">
                <v-select
                  :options="listOfTypes"
                  label="label"
                  :reduce="(o) => o.value"
                  v-model="form.type"
                  :clearable="false"
                  class="w-full"
                  :disabled="updateMode"
                />
              </div>
            </div>

            
            <div
              class="vx-col w-full md:w-1/2 flex items-center"
              v-if="updateMode"
            >
              
              <div class="w-1/3 pr-3">
                <label class="text-sm font-semibold">Status</label>
              </div>

             
              <div class="w-2/3">
                <ValidationProvider
                  rules="required"
                  name="Status"
                  v-slot="{ errors }"
                >
                  <v-select
                    :options="statusOptions"
                    v-model="form.status"
                    @input="updateStatus"
                    :reduce="(option) => option.value"
                    label="label"
                    placeholder="Select status"
                    :clearable="false"
                    class="w-full vs-select-lg"
                  />

                  <span v-if="errors[0]" class="text-danger text-xs mt-1 block">
                    {{ errors[0] }}
                  </span>
                </ValidationProvider>
              </div>
            </div>
          </div>
          

          <vx-card
            v-if="form.type == 'Work Order' && !updateMode"
            title="Work Orders"
            class="mb-6 shadow-sm"
          >
            <div v-can="'view-work-orders'" slot="no-body" class="p-4">
              <div class="vx-col md:w-1/4 sm:w-1/2 w-full mb-3">
                <label class="text-sm font-semibold mb-2 block">Search</label>
                <vs-input
                  type="search"
                  placeholder="Search work orders..."
                  v-model="woSearchTxt"
                  @input="searchWo(woSearchTxt)"
                  class="w-full"
                />
              </div>

              <vs-table
                id="wo-list-table"
                :data="woList"
                :sst="true"
                v-model="selectedWo"
                @selected="handleSelectedWo"
                :multiple="false"
                :selectable="true"
              >
                <template slot="thead">
                  <vs-th width="15%">WORK ORDER CODE</vs-th>
                  <vs-th width="20%">ITS PRODUCT CODE/NAME</vs-th>
                  <vs-th width="10%">MANUFACTURING DATE</vs-th>
                  <vs-th width="10%"></vs-th>
                  
                </template>

                <template slot-scope="{ data }">
                  <vs-tr
                    v-for="(tr, indextr) in data"
                    :key="indextr"
                    :data="tr"
                    style="cursor: pointer"
                  >
                    <vs-td>{{ tr.work_order_code }}</vs-td>
                    <vs-td>{{ tr.formulation_code }}</vs-td>
                    <vs-td>{{ tr.work_order_date || "N/A" }}</vs-td>

                    <vs-td class="text-right pr-4">
                      <span
                        v-if="
                          selectedWo &&
                          selectedWo.work_order_code === tr.work_order_code
                        "
                        class="px-2 py-1 text-xs rounded bg-primary text-white"
                      >
                        Selected
                      </span>
                    </vs-td>
                  </vs-tr>
                </template>
              </vs-table>
            </div>
          </vx-card>

          <vx-card
            v-if="form.type == 'Raw Material Inventory' && !updateMode"
            title="Raw Material Inventory"
            class="mb-6 shadow-sm"
          >
            <div v-can="'view-work-orders'" slot="no-body" class="p-4">
              <div class="vx-col md:w-1/4 sm:w-1/2 w-full mb-3">
                <label class="text-sm font-semibold mb-2 block">Search</label>
                <vs-input
                  type="search"
                  placeholder="Search raw material..."
                  v-model="rmInventorySearchTxt"
                  @input="searchRmInventory(rmInventorySearchTxt)"
                  class="w-full"
                />
              </div>

              <vs-table
                id="rm-list-table"
                :data="rmInventoryList"
                :sst="true"
                v-model="selectedRmInventory"
                @selected="handleSelectedWo"
                :multiple="false"
                :selectable="true"
              >
                <template slot="thead">
                  <vs-th width="15%">BATCH NO</vs-th>
                  <vs-th width="15%">COMPANY PRODUCT CODE</vs-th>
                  <vs-th width="15%">CATEGORY</vs-th>
                  <vs-th width="15%">SUPPLIER</vs-th>
                  <vs-th width="10%"></vs-th>
                  
                </template>

                <template slot-scope="{ data }">
                  <vs-tr
                    v-for="(tr, indextr) in data"
                    :key="indextr"
                    :data="tr"
                    :selected="
                      selectedRmInventory &&
                      selectedRmInventory.batch_no === tr.batch_no
                    "
                    style="cursor: pointer"
                  >
                    <vs-td>{{ tr.batch_no }}</vs-td>
                    <vs-td>{{ tr.company_product_code }}</vs-td>
                    <vs-td>{{ tr.category }}</vs-td>
                    <vs-td>{{ tr.supplier || "N/A" }}</vs-td>

                    
                    <vs-td class="text-right pr-4">
                      <span
                        v-if="
                          selectedRmInventory &&
                          selectedRmInventory.batch_no === tr.batch_no
                        "
                        class="px-2 py-1 text-xs rounded bg-primary text-white"
                      >
                        Selected
                      </span>
                    </vs-td>
                  </vs-tr>
                </template>
              </vs-table>
            </div>
          </vx-card>

          <h5 class="font-semibold mb-3 mt-6 border-b pb-1">Properties</h5>

          <div
            v-for="(prop, key) in ['Appearance', 'Odour', 'Taste']"
            :key="key"
            class="vx-row mb-4 border p-4 rounded-lg"
          >
            <div class="vx-col w-full md:w-1/4 flex items-center">
              <small class="font-semibold">{{ prop }}</small>
            </div>

            <div class="vx-col w-full md:w-1/2">
              <ValidationProvider
                :vid="`${prop}_comment`"
                :name="`${prop}_comment`"
                rules="required"
                v-slot="{ errors }"
              >
                <vs-input
                  v-model="form.properties[prop].comment"
                  class="w-full"
                  placeholder="Comment"
                  :disabled="!canEdit"
                />
                <span class="text-danger text-sm">{{ errors[0] }}</span>
              </ValidationProvider>
            </div>

            <div class="vx-col w-full md:w-1/4">
              <ValidationProvider
                :vid="`${prop}_status`"
                :name="`${prop}_status`"
                rules="required"
                v-slot="{ errors }"
              >
                <v-select
                  :options="propertyTypeOptions"
                  label="label"
                  :reduce="(o) => o.value"
                  v-model="form.properties[prop].status"
                  :clearable="false"
                  class="w-full"
                  :disabled="!canEdit"
                />
                <span class="text-danger text-sm">{{ errors[0] }}</span>
              </ValidationProvider>
            </div>
          </div>

          <h5 class="font-semibold mb-3 mt-8 border-b pb-1">
            Optional Properties
          </h5>

          <div
            v-if="materialType == 'liquid'"
            class="vx-row mb-3 border p-3 rounded-lg"
          >
            <div class="vx-col w-full md:w-1/4 flex items-center">
              <small>Specific Gravity</small>
            </div>
            <div class="vx-col w-full md:w-3/4">
              <vs-input
                v-model="form.optional_properties.specific_gravity"
                class="w-full"
                placeholder="Response"
                :disabled="!canEdit"
              />
            </div>
          </div>

          <div
            v-if="materialType == 'liquid'"
            class="vx-row mb-3 border p-3 rounded-lg"
          >
            <div class="vx-col w-full md:w-1/4 flex items-center">
              <small>Refractive Index</small>
            </div>
            <div class="vx-col w-full md:w-3/4">
              <vs-input
                v-model="form.optional_properties.refractive_index"
                class="w-full"
                placeholder="Response"
                :disabled="!canEdit"
              />
            </div>
          </div>

          <div
            v-if="materialType == 'powder'"
            class="vx-row mb-3 border p-3 rounded-lg"
          >
            <div class="vx-col w-full md:w-1/4 flex items-center">
              <small>Moisture</small>
            </div>
            <div class="vx-col w-full md:w-3/4">
              <vs-input
                v-model="form.optional_properties.moisture"
                class="w-full"
                placeholder="Response"
              />
            </div>
          </div>

          <div class="vx-row mb-3 border p-3 rounded-lg">
            <div class="vx-col w-full md:w-1/4 flex items-center">
              <small>Target</small>
            </div>
            <div class="vx-col w-full md:w-3/4">
              <vs-input
                v-model="form.optional_properties.target"
                class="w-full"
                placeholder="Response"
                :disabled="!canEdit"
              />
            </div>
          </div>
          <div class="vx-col w-full">
            <label class="text-sm font-semibold mb-1 block">Note</label>
            <vs-textarea
              v-model="form.notes"
              class="w-full"
              placeholder="Add a note..."
              :disabled="!canEdit"
            />
          </div>

          <h5 class="font-semibold mb-3 mt-8 border-b pb-1">Attachments</h5>

          <FilePreviewGallery
            :removable="true"
            :files="form.file_paths"
            @remove="removeFile"
            class="mb-4"
          />

          <multi-file-uploader
            v-if="canEdit"
            v-on:onSetFileName="onSetFiles($event)"
            :file="''"
            file_path="ccp-item/attachments"
            :condition="true"
            class="mb-4"
          />

          <div class="flex flex-wrap items-center justify-end mt-10">
            <vs-button
              icon-pack="feather"
              icon="icon-save"
              button="submit"
              color="primary"
              class="ml-auto mt-2"
              v-can="'create-edit-quality-control-tastings'"
            >
              Submit
            </vs-button>

            <vs-button
              @click="resetForm"
              icon-pack="feather"
              icon="icon-x"
              color="danger"
              class="ml-2 mt-2"
            >
              Clear
            </vs-button>
          </div>
        </form>
      </ValidationObserver>
    </vx-card>
  </vs-popup>
</template>

<script>
import vSelect from "vue-select";
import "vue-select/dist/vue-select.css";
import { RepositoryFactory } from "@/repository/RepositoryFactory";
import SuccessMessage from "@/mixins/SuccessMessage";
import ErrorMessages from "@/mixins/ErrorMessages";
import moment from "moment";
import FilePreviewGallery from "@/components/shared/FilePreviewGallery.vue";

const TriangleTestsRepository = RepositoryFactory.get("triangle_tests");
const ManufacturingRepository = RepositoryFactory.get("manufacturing");

function initialState() {
  return {
    open: false,
    id: "",
    form: {
      id: 1,
      type: "Work Order",
      properties: {
        Appearance: { comment: "", status: "" },
        Odour: { comment: "", status: "" },
        Taste: { comment: "", status: "" },
      },
      optional_properties: {
        specific_gravity: "",
        refractive_index: "",
        moisture: "",
        target: "",
      },
      notes: "",
      file_paths: [],
    },
    propertyTypeOptions: [],
    listOfTypes: [],
    listOfStatuses: [],
    woList: [],
    selectedWo: null,
    rmInventoryList: [],
    selectedRmInventory: null,
    materialType: "",
    woSearchTxt: "",
    rmInventorySearchTxt: "",
    updateMode: false,
    batchCode: "",
    statusOptions: [],
    doneBy:{},
  };
}

export default {
  data() {
    return initialState();
  },
  methods: {
    async openPopup(id = null) {
      try {
        await Object.assign(this.$data, initialState());
        if (id != null) {
          this.id = id;
          this.fetchTestDetails(id);
          this.updateMode = true;
        }
        await this.getListOfPropertyTypes();
        await this.getListOfTypes();
        await this.getListOfStatuses();
        await this.fetchStatusList();
        this.open = true;
      } catch (error) {}
    },
    async updateStatus(status) {
      try {
        this.$vs.loading();
        await TriangleTestsRepository.updateFormTestingStatus(this.id, {
          status: status,
        });
        this.$emit("refresh");
      } catch (error) {
        this.convertAndNotifyError(e);
      } finally {
        this.$vs.loading.close();
      }
    },
    async createTest() {
      try {
        this.$vs.loading();
        const payload = {
          id: this.form.id,
          type: this.form.type,
          properties: [
            {
              ...this.form.properties.Appearance,
              name: "Appearance",
            },
            {
              ...this.form.properties.Odour,
              name: "Odour",
            },
            {
              ...this.form.properties.Taste,
              name: "Taste",
            },
          ],
          optional_properties: [
            {
              response: this.form.optional_properties.specific_gravity,
              name: "Specific Gravity",
            },
            {
              response: this.form.optional_properties.refractive_index,
              name: "Refractive Index",
            },
            {
              response: this.form.optional_properties.moisture,
              name: "Moisture",
            },
            {
              response: this.form.optional_properties.target,
              name: "Target",
            },
          ],
          notes: this.form.notes,
          file_paths: this.form.file_paths,
        };
        if (this.updateMode) {
          await TriangleTestsRepository.updateQualityControlTestings(
            this.id,
            payload
          );
        } else {
          await TriangleTestsRepository.createQualityControlTestings(payload);
        }
        this.$emit("refresh");
        this.open = false;
      } catch (e) {
      } finally {
        this.$vs.loading.close();
      }
    },
    onSetFiles(file_path) {
      this.form.file_paths.push(file_path);
    },

    removeFile(index) {
      this.form.file_paths.splice(index, 1);
    },
    async fetchTestDetails(id) {
      try {
        this.$vs.loading();
        const response =
          await TriangleTestsRepository.getQualityControlTestDetails(id);
        this.mapWorkOrderToForm(response.data.data);
      } catch (e) {
      } finally {
        this.$vs.loading.close();
      }
    },
    resetForm() {
      this.form = {
        id: 1,
        type: "Work Order",
        properties: {
          Appearance: { comment: "", status: "" },
          Odour: { comment: "", status: "" },
          Taste: { comment: "", status: "" },
        },
        optional_properties: {
          specific_gravity: "",
          refractive_index: "",
          moisture: "",
          target: "",
        },
        notes: "",
        file_paths: [],
      };
    },
    async getListOfStatuses() {
      const response = await TriangleTestsRepository.getListOfStatuses();
      this.listOfStatuses = response.data.data;
    },
    async getListOfTypes() {
      const response = await TriangleTestsRepository.getListOfTypes();
      this.listOfTypes = response.data.data;
    },
    async getListOfPropertyTypes() {
      const response = await TriangleTestsRepository.getListOfPropertyTypes();
      this.propertyTypeOptions = response.data.data;
    },
    async getListOfWo(searchText = "") {
      try {
        this.$vs.loading();
        const response = await ManufacturingRepository.getAllWorkOrders(
          1,
          `filter[search]=${searchText}`
        );
        this.woList = response.data.data;
      } catch (e) {
      } finally {
        this.$vs.loading.close();
      }
    },
    async fetchStatusList() {
      try {
        const response =
          await TriangleTestsRepository.getFormTestingStatusList();
        this.statusOptions = response.data.data;
      } catch (e) {}
    },
    searchWo: _.debounce(async function (search) {
      await this.getListOfWo(search);
    }, 1000),
    searchRmInventory: _.debounce(async function (search) {
      await this.getInventoryList(search);
    }, 1000),

    handleSelectedWo(selected) {
      this.form.id = selected.id;
      this.materialType = selected.formulation_type;
    },
    handleSelectedInventory(selected) {
      this.form.id = selected.id;
      this.materialType = selected.raw_material_texture;
    },

    async getInventoryList(searchText = "") {
      try {
        this.$vs.loading;
        const response = await ManufacturingRepository.getRawMaterialStock(
          1,
          `filter[search]=${searchText}`
        );
        this.rmInventoryList = response.data.data;
      } catch (e) {
      } finally {
        this.$vs.loading.close();
      }
    },

    mapWorkOrderToForm(data) {
      this.form.id = data.batch_id;
      this.form.type = data.batch_type;

      const mappedProps = {};
      if (data.properties && Array.isArray(data.properties)) {
        data.properties.forEach(function (prop) {
          mappedProps[prop.name] = {
            comment: prop.comment || "",
            status: prop.status || "",
          };
        });
      }

      this.selectedWo = data.batch;
      this.batchCode = this.getBatchCode(data);
      this.doneBy = data.done_by

      this.form.properties = {
        Appearance: mappedProps["Appearance"] || { comment: "", status: "" },
        Odour: mappedProps["Odour"] || { comment: "", status: "" },
        Taste: mappedProps["Taste"] || { comment: "", status: "" },
      };

      const mappedOptionalProps = {};
      if (data.optional_properties && Array.isArray(data.optional_properties)) {
        data.optional_properties.forEach(function (opt) {
          if (opt.name) {
            var key = opt.name.toLowerCase().replace(/\s+/g, "_");
            mappedOptionalProps[key] = opt.response || "";
          }
        });
      }

      this.form.optional_properties = {
        specific_gravity: mappedOptionalProps["specific_gravity"] || "",
        refractive_index: mappedOptionalProps["refractive_index"] || "",
        moisture: mappedOptionalProps["moisture"] || "",
        target: mappedOptionalProps["target"] || "",
      };

      this.form.notes = data.notes;
      this.form.status = data.status;
      this.form.file_paths = data.file_paths || [];
    },
    getBatchCode(dataSet) {
      if (dataSet.batch_type === "Work Order") {
        return dataSet.batch.work_order_code;
      } else {
        return dataSet.batch.code;
      }
    },
  },
  computed: {
    canEdit() {
      return this.$can && this.$can("create-edit-quality-control-tastings'");
    },
  },

  components: {
    "v-select": vSelect,
    FilePreviewGallery,
  },
  mixins: [SuccessMessage, ErrorMessages],
};
</script>
<style scoped>
.taste-panel-create-popup >>> .vs-popup {
  /*min-height: 50% !important;*/
  min-width: 80% !important;
}
</style>
